// extracted by mini-css-extract-plugin
module.exports = {"title":"BlogIndexPage_title__2T3sf","articlesList":"BlogIndexPage_articlesList__2Ubxn","footer":"BlogIndexPage_footer__2h91w","logo":"BlogIndexPage_logo__1zO3y"};